import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

/**
 * @param {String} cssClassName
 */
const createPortalWrapper = cssClassName => {
  const wrapper = document.createElement('div');
  wrapper.classList.add(cssClassName);
  document.body.appendChild(wrapper);

  return wrapper;
};

const BannerPortal = forwardRef(
  (
    { children, defaultOpened = false, wrapperCssClass = 'bb-banners', alwaysOpen = false },
    ref,
  ) => {
    const [isOpen, setIsOpen] = useState(defaultOpened);
    const [wrapper, setWrapper] = useState(null);
    const close = useCallback(() => {
      setIsOpen(false);
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        open: () => setIsOpen(true),
        close,
        isOpen,
      }),
      [close],
    );

    useLayoutEffect(() => {
      let element = document.querySelector(`.${wrapperCssClass}`);
      let created = false;

      if (!element) {
        element = createPortalWrapper(wrapperCssClass);
        created = true;
      }
      setWrapper(element);

      return () => {
        if (created && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      };
    }, [wrapperCssClass]);

    if (!wrapper || (!isOpen && !alwaysOpen)) return null;

    return createPortal(<>{children}</>, document.querySelector(`.${wrapperCssClass}`));
  },
);

BannerPortal.propTypes = {
  wrapperCssClass: PropTypes.string,
  children: PropTypes.node.isRequired,
  alwaysOpen: PropTypes.bool,
  defaultOpened: PropTypes.bool,
};

export default BannerPortal;
